import { Route, Routes } from 'react-router-dom';
import RunActivityList from './run-activity-list';
import RunActivityItem from './run-activity-item';
import ShiftActivityItem from './shift-activity-item';

const RunActivityRouting = () => {
  return (
    <Routes>
      <Route path='' element={<RunActivityList />} />
      <Route path=':uid' element={<RunActivityItem />} />
      <Route path=':uid/shift-activity/:shiftActivityUid' element={<ShiftActivityItem />} />
    </Routes>
  );
};

export default RunActivityRouting;
